<template>
  <div ref="list">
    <div v-if="isData">
      <slot name="list"></slot>
      <div class="page-box" v-if="isPage">
        <el-pagination
          v-if="isPages"
          background
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10,50,100,200]"
          :page-size="pages"
          layout="sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
        <el-pagination
          v-else
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :page-size="pages"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div v-else>
      <div class="nodata" style="padding-top:40px;">
        <img src="../../assets/images/nodata.png" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    //请求的url地址
    url: {
      type: String,
      required: true
    },
    //需要传递的参数
    search: {
      type: Object,
      default() {
        return {};
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    //是否分页
    isPage: {
      type: Boolean,
      default: true
    },
    isPages:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage:1,
      isData: false,
      total: 0,
      list: [],
      page: 0, //总页数
      nowPage: 1, //本页
      pages:10,
      loading: false, //一步加载时的限制
      bottomHight: 50 //滚动条到某个位置才触发时间
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pages = val
      this.getList();
    },
    handleCurrentChange(val) {
    },

    currentChange(page) {
      this.nowPage = page;
      this.getList();
    },

    /**
     * 刷新表格
     */
    reloadTable() {
      // 加载状态
      const loading = this.$loading({
        target: this.$refs.list,
        lock: true,
        text: "数据加载中"
      });
      this.$db.setSearch(this.search);
      // 发起请求
      this.$db.list(this.url).then(resp => {
        if (resp && resp.data.data.length) {
          this.isData = true;
          resp.data.data.forEach(element => {
            this.list.push(element);
          });
          this.page = resp.data.last_page;
          this.total = resp.data.total;
          this.loading = false;
        } else {
          this.isData = false;
        }
        this.$emit("input", this.list);
        this.list = [];
        loading.close();
      });
    },

    /**
     * 搜索触发
     * @return {[type]} [description]
     */
    handleSearch() {
      const loading = this.$loading({
        target: this.$refs.list,
        lock: true,
        text: "数据加载中"
      });
      this.$db.setSearch(this.search);
      this.$db.list(this.url).then(resp => {
        if (resp && resp.data.data.length) {
          this.isData = true;
          resp.data.data.forEach(element => {
            this.list.push(element);
          });
          this.page = resp.data.last_page;
          this.total = resp.data.total;
          this.loading = false;
        } else {
          this.isData = false;
        }
        this.$emit("input", this.list);
        this.list = [];
        loading.close();
      });
    },
    getList() {
      const loading = this.$loading({
        target: this.$refs.list,
        lock: true,
        text: "数据加载中"
      });
      this.$db.setPage(this.nowPage);
      this.$db.setPageSize(this.pages);
      this.$db.setSearch(this.search);
      this.$db.list(this.url).then(resp => {
        if (resp && resp.data.data.length) {
          this.isData = true;
          resp.data.data.forEach(element => {
            this.list.push(element);
          });
          this.page = resp.data.last_page;
          this.total = resp.data.total;
          this.loading = false;
        } else {
          this.isData = false;
        }
        this.$emit("input", this.list);
        this.list = [];
        loading.close();
      });
    },
  },
  mounted() {
    this.pages = this.pageSize
    this.getList();
    //window.addEventListener("scroll", this.handleScroll);
  },
  //页面销毁，页面销毁时移除监听事件，否则其他页面也会自动进入scroll的监听中
  destroyed() {
    //window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.page-box {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 50px;
  text-align: center;
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #e83a16;
  border: solid 1px #e83a16;
}

.nodata {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.nodata img {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataList/lists.vue